import type { ApiClient } from "./apiClient";

/** The subset of packages/frontend/src/services/user.ts the admin Security page needs. */

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export function createUserApi(api: ApiClient) {
  return {
    changePassword: (data: ChangePasswordRequest) =>
      api.post<{ message: string }>("/users/me/change-password", data),
  };
}

export type UserApi = ReturnType<typeof createUserApi>;
